import React, { useMemo, useState } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { useTranslation } from '@common/hooks/translation';
import { GetArrayMarket } from '@common/helpers/util/swarmTreeDestructuring';
import { RacingMarketTypes } from '@common/constants/enums/racingMarketTypes';
import { eventsListSorter } from '@racings/helpers/eventsListSorter';

import './styles.scss';
import { RacingFutureSpecialEvent } from '../racingEvent/racingFutureSpecialEvent';

export const RacingFutureSpecialGame = ({ game, activeGameId, competitionName }) => {
  const t = useTranslation();
  const [activeMarketId, setActiveMarketId] = useState(RacingMarketTypes.WINNER);

  const marketsList = useMemo(() => {
    const list = [
      {
        id: RacingMarketTypes.WINNER,
        label: 'Winner',
      },
    ];

    if (game.game_info?.IsForecastAvailable) {
      list.push({
        id: RacingMarketTypes.FORECAST,
        label: 'Forecast',
      });
    }

    if (game.game_info?.IsTricastAvailable) {
      list.push({
        id: RacingMarketTypes.TRICAST,
        label: 'Tricast',
      });
    }

    return list;
  }, [game.game_info]);

  const markets = GetArrayMarket(game.market);
  const winnerMarket = markets.find((market) => market.market_type === 'Winner');
  const events = winnerMarket?.event && Object.values(winnerMarket.event).sort(eventsListSorter);
  const extraInfo = winnerMarket?.extra_info;

  return (
    <div key={game.id} className="racing-game-container">
      <div className="info-container">
        <div
          className='racing-game-info row'
        >
          <div className="region-info info-item">
            <span className={`flag icon-${game.region_alias?.toLowerCase().replaceAll(' ', '')} flag`} />

            <span className="competition-name">{competitionName}</span>
          </div>
          {!activeGameId && (
            <div className="game-date info-item">{moment.unix(game.start_ts).format('HH:mm - ddd DD MMM')}</div>
          )}
          <div className="game-number-wrapper info-item">
            {t('Round Id')}
            {' '}
            <span>{game.game_number}</span>
          </div>
          {extraInfo && activeMarketId === RacingMarketTypes.WINNER && (
            <div className="game-number-wrapper info-item">
              {t('Each Way')}
              {' '}
              <span>
                1/
                {winnerMarket.extra_info.EachWayK}
                {' '}
                {t('Odds')}
                {' '}
                {extraInfo.EachWayPlace}
                {' '}
                {t('Places')}
              </span>
            </div>
          )}
        </div>
        <div className="markets-list">
          {marketsList.map((market) => (
            <div
              key={market.id}
              onClick={() => setActiveMarketId(market.id)}
              className={classnames('market-item', {
                active: activeMarketId === market.id,
              })}
            >
              {market.label}
            </div>
          ))}
        </div>
      </div>
      <div className="fs-events-container">
        {events?.map((event, ind) => (
          <RacingFutureSpecialEvent
            key={event.id}
            event={event}
            game={game}
            market={winnerMarket}
            number={ind + 1}
            activeMarketId={activeMarketId}
            marketDisplayKey={winnerMarket.display_key}
          />
        ))}
      </div>
    </div>
  );
};
